
export default {
  name: 'TabsSlice',
  props: ['slice'],
  data() {
    return {
      activeIndex: 0,
      page: 1,
      pageSize: 4,
      tabsId: 'tab' + Math.floor(Math.random() * (1000 - 1 + 1) + 1)
    }
  },
  computed: {
    showAll() {
      return this.slice.primary.show_all_tabs_content
    }
  },
  watch: {
    activeIndex(){
      setTimeout(()=>{
        const el = document.querySelector(`#${this.tabsId} .tabs-slice__col--content`)
        el.scroll({
        left: document.querySelector(`#${this.tabsId} .tabs-slice__tab.active`).offsetLeft - 10,
        top: 0,
        behavior: 'smooth'
      })
      }, 100)

    }
  },
  methods: {
    slide(direction) {
      if (direction === '-') {
        this.page === 1 ? this.page = Math.round(this.slice.items.length / this.pageSize) : this.page--
      } else {
        this.page < Math.round(this.slice.items.length / this.pageSize) ? this.page++ : this.page = 1
      }
      this.activeIndex = Math.round((this.page - 1) * this.pageSize)
    }
  }
}
